import {type UserNs} from "@shared/types/user.namespace";

export namespace ProjectNs {

  export enum ProjectRoleEnums {
    ADMIN = "ADMIN",
    OWNER = "OWNER",
    MANAGER = 'MANAGER',
    EDITOR = 'EDITOR',
    VIEWER = 'VIEWER'
  }

  export enum JiraSyncMode {
    ONLY_IMPORT = "ONLY_IMPORT",
    MANUAL_SYNC = "MANUAL_SYNC",
    AUTO_SYNC = 'AUTO_SYNC'
  }

  export interface Member {
    id: number,
    avatar: string,
    socialAvatar: string,
    fullNameAvatar: string,
    projectRole: string,
    userName: string,
    fullName: string,
    status: 'ACTIVE' | 'PENDING'
  }

  export interface ProjectIntegration {
    integrationType: string,
    integrationBaseUrl: string,
    synchronizationType: JiraSyncMode.ONLY_IMPORT | JiraSyncMode.MANUAL_SYNC | JiraSyncMode.AUTO_SYNC
  }

  export interface ProjectDetail {
    appDetailStep: number,
    appSummary: string,
    appType: string[],
    specifiedAppType: string[],
    aiLanguage: string,
    businessModel: string[],
    appRole: string[],
    device: string[],
    techStack: string[],
    techStackFrontend: string[],
    techStackBackend: string[],
    techStackDatabase: string[],
    targetBranch: string[],
    techBranch: string[],
    targetGroup: string[]
  }

  export interface Project {
    id: string,
    name: string,
    key: string,
    projectRole: string,
    projectMembersList: Member[],
    projectIntegrationList: ProjectIntegration[],
    workspaceIntegrationList: string[],
    branchType: string,
    branch: string,
    platformType: string,
    platform: string,
    targetGroup: string,
    trashedBy: UserNs.AuditUser,
    trashedDate: Date,
    createdBy: UserNs.AuditUser,
    createDate: Date,
    updatedBy: UserNs.AuditUser,
    updateDate: Date,
    searchable: boolean
  }

  /** Get All Project In Workspace */
  export interface GetProjectsInWorkspaceRequest {
    workspaceId: string,
  }

  /** Get User Project In Workspace */
  export interface GetUserProjectsInWorkspaceRequest {
    workspaceId: string,
    userId: number,
    userName: string,
  }

  /** Get Project From Trash */
  export interface GetProjectFromTrashRequest {
    workspaceId: string
  }

  /** Add Project */
  export interface AddProjectRequest {
    projectName: string,
    workspaceId: string,
    containerId: number
  }

  /** Update Project */
  export interface UpdateProjectRequest {
    workspaceId: string,
    projectId: string,
    name: string,
    description: string,
  }

  /** Update Project Detail */
  export interface UpdateProjectDetailRequest {
    workspaceId: string,
    projectId: string,
    projectDetail: ProjectDetail
  }

  export interface AddProjectResponse {
    projectId: string,
    result: string
  }

  /** Move Project */
  export interface MoveProjectRequest {
    fromContainerId: number,
    toContainerId: number,
    projectId: string
  }

  /** Get Project */
  export interface GenericProjectRequest {
    workspaceId: string,
    projectId: string
  }

  export interface ProjectContents {
    pages: number,
    modules: number,
    /** FEATURE + SUB_FEATURE, summed server-side because they share one tile. */
    features: number,
    sources: number,
    screens: number,
    estimations: number
  }

  export interface ChangeProjectMemberStatusRequest {
    workspaceId: string,
    projectId: string,
    userName: string,
    projectRole: string
  }

  /** Get Project Member List */
  export interface GetProjectMembersRequest {
    workspaceId: string,
    projectId: string,
  }

  export interface PublishProjectRequest {
    workspaceId: string,
    projectId: string,
    password: string,
    allowComments?: boolean,
    showProperties?: boolean,
    showJiraLinks?: boolean
    isPasswordProtected: boolean
    isImportable: boolean
  }

  export interface PublishProjectResponse {
    projectName: string,
    token: string,
    allowComments: boolean,
    showProperties: boolean,
    showJiraLinks: boolean,
    isPasswordProtected: boolean,
    isImportable: boolean,
    isEstimation: boolean,
  }

}
